import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import WithLabel, { LABEL_STYLES } from '../../../../components/with-label/WithLabel';
import { COMMON_PAGE_SIZE_OPTIONS } from '../../../../constants';
import CommonDropdown from '../../../../components/common-dropdown/CommonDropdown';
import { changeTableSize } from '../../../../redux/user-management/userManagementReducer';

import scss from './SystemUsersFilters.module.scss';
import TooltipButton from '../../../../components/tooltip-button/TooltipButton';
import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';
import { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';

function SystemUsersFilters() {
  const { t } = useTranslation('userManagement');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const size = useSelector((state) => state.userManagement.tableSettings.size);

  const handleChangeTableSize = (newSize) => {
    dispatch(changeTableSize(newSize));
  };

  const handleAddUser = () => {
    navigate('/users/create');
  };

  return (
    <div className={scss.wrapper}>
      <TooltipButton styleColor={BUTTON_STYLES.PRIMARY} onClick={handleAddUser} maxWidth={180}>
        <Icon icon={ICONS.CirclePlus} />
        {t('addUser')}
      </TooltipButton>

      <WithLabel label={t('show')} variant={LABEL_STYLES.ROW} isBold maxWidth={150}>
        <CommonDropdown options={COMMON_PAGE_SIZE_OPTIONS} value={size} onSelect={handleChangeTableSize} />
      </WithLabel>
    </div>
  );
}

export default SystemUsersFilters;
